<template>

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="382.000000pt" height="331.000000pt" viewBox="0 0 382.000000 331.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.16, written by Peter Selinger 2001-2019
</metadata>
<g transform="translate(0.000000,331.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2900 3272 c-46 -45 -59 -96 -37 -140 14 -29 14 -29 -45 -77 l-58
-47 -66 12 c-108 21 -263 -5 -398 -64 l-55 -24 -11 34 c-18 53 -57 94 -90 94
-63 0 -103 -65 -121 -197 -9 -64 -15 -80 -37 -97 -15 -11 -66 -57 -113 -103
-75 -73 -90 -83 -121 -83 -167 0 -431 -76 -591 -170 l-67 -39 0 28 c0 64 11
90 41 96 61 14 98 94 65 141 -13 19 -10 23 45 67 32 26 59 52 59 57 0 6 14 10
30 10 34 0 79 20 99 44 20 24 30 84 20 118 -11 41 3 58 48 58 36 0 83 36 83
64 0 30 -23 65 -51 76 -39 17 -81 -5 -95 -48 -15 -47 -31 -54 -73 -31 -71 38
-148 15 -177 -51 -12 -26 -31 -43 -68 -63 -70 -37 -151 -119 -172 -174 -26
-66 -12 -111 43 -137 57 -28 56 -61 -4 -117 -51 -47 -88 -64 -158 -75 l-49 -7
27 33 c105 125 148 334 91 448 -50 100 -122 138 -393 206 -198 49 -298 91
-369 151 -46 40 -62 41 -40 3 9 -16 13 -59 12 -138 -1 -107 -4 -126 -49 -275
-60 -201 -70 -313 -35 -387 24 -51 66 -89 134 -118 53 -24 155 -48 218 -52 27
-2 48 -4 48 -4 0 -1 -22 -16 -50 -34 -75 -48 -149 -133 -156 -181 -5 -30 -12
-41 -30 -45 -35 -9 -30 -20 19 -39 53 -21 107 -62 107 -80 0 -23 41 -55 70
-55 32 0 60 28 60 58 0 25 -33 62 -55 62 -26 0 -41 46 -25 75 14 26 93 69 145
79 29 6 31 4 76 -84 l46 -90 -141 -94 c-78 -52 -194 -138 -258 -191 l-118 -96
0 -107 c0 -171 27 -347 76 -504 14 -43 27 -78 29 -78 2 0 83 -21 181 -46 l178
-46 35 38 c19 21 36 33 38 28 2 -5 21 -37 42 -69 l39 -59 -19 -24 c-22 -29
-24 -61 -5 -87 10 -14 11 -26 3 -52 -13 -42 -39 -40 -48 2 -6 25 -7 26 -8 6
-1 -14 -6 -21 -13 -18 -7 3 -29 12 -49 21 l-36 15 -8 -91 c-6 -78 -11 -98 -36
-134 -78 -114 -57 -221 60 -295 35 -23 57 -29 98 -29 63 0 103 18 158 70 29
28 59 44 111 59 39 12 79 21 88 21 25 0 19 18 -19 63 l-36 41 45 23 c38 19 49
21 71 11 22 -10 30 -8 54 10 l29 21 74 -30 c374 -155 854 -120 1206 86 220
129 428 351 522 559 27 58 34 67 55 64 14 -2 33 6 48 20 l25 23 7 -112 7 -112
92 6 c60 4 125 16 190 36 55 17 101 32 102 34 2 2 -3 43 -11 92 -8 49 -13 90
-12 92 2 1 11 -20 21 -48 10 -27 20 -48 23 -46 2 3 -8 33 -22 68 -15 35 -32
94 -40 132 l-13 67 48 38 c42 32 49 44 60 92 6 30 14 101 17 157 l6 102 -43
48 c-56 64 -185 180 -277 250 -70 52 -78 55 -104 46 -24 -9 -43 -5 -138 36
l-109 48 64 12 c100 18 290 78 377 119 54 24 91 50 117 79 32 37 43 43 76 43
59 0 82 -10 88 -36 8 -31 61 -64 103 -64 43 0 93 43 93 80 0 61 -77 112 -136
90 -16 -6 -36 -17 -44 -25 -11 -9 -35 -12 -85 -8 -66 5 -71 7 -86 37 -20 41
-102 89 -187 111 -39 10 -124 19 -203 22 l-135 6 4 86 c3 47 10 89 16 94 19
13 168 58 211 64 36 5 45 2 71 -25 71 -71 206 -55 250 29 45 89 -14 179 -119
179 -84 0 -157 -52 -157 -113 0 -22 -5 -25 -51 -31 -44 -6 -160 -39 -210 -60
-12 -5 -18 3 -27 32 -13 44 -82 127 -112 137 -28 9 -25 15 31 58 45 36 52 38
81 28 46 -16 79 -13 122 12 84 48 98 143 32 204 -31 29 -42 33 -92 33 -52 0
-59 -3 -94 -38z m161 -21 c41 -41 39 -83 -5 -127 -28 -28 -41 -34 -72 -33
l-39 2 44 7 c69 11 111 73 81 120 -8 12 -10 11 -10 -6 0 -35 -46 -69 -91 -68
-21 1 -46 7 -54 14 -22 18 -18 -3 6 -36 l21 -29 -26 28 c-32 34 -33 75 -5 111
42 54 106 61 150 17z m-2762 -186 c62 -47 116 -85 120 -85 3 0 11 -10 16 -22
12 -27 33 -30 59 -9 18 15 18 15 7 -6 -6 -12 -15 -24 -20 -27 -4 -3 -14 -26
-21 -50 l-12 -45 -82 6 c-111 8 -180 -12 -230 -67 -31 -35 -36 -47 -36 -90 0
-68 28 -120 91 -170 28 -22 48 -40 44 -40 -17 0 -77 44 -106 78 -17 20 -29 29
-26 20 9 -25 0 -22 -14 3 -9 17 -8 20 2 14 9 -6 10 -4 3 11 -5 10 -9 53 -9 94
1 57 6 87 24 125 35 76 50 141 57 248 4 53 10 97 13 97 3 0 57 -38 120 -85z
m2466 -104 c28 -12 62 -34 78 -48 28 -27 37 -50 15 -37 -8 4 -10 3 -5 -2 5 -5
14 -9 20 -9 19 0 35 -75 36 -162 1 -80 -22 -220 -38 -236 -5 -5 0 27 10 70 19
80 25 230 10 268 -6 15 -10 2 -16 -45 -9 -85 -30 -172 -56 -240 -36 -96 -99
-219 -115 -228 -14 -8 -14 -10 0 -21 9 -8 16 -18 16 -24 0 -6 -15 3 -32 20
-179 169 -472 287 -767 309 l-92 7 72 66 c188 172 384 283 574 327 89 20 228
13 290 -15z m-2009 -21 c14 -14 32 -37 40 -52 17 -33 17 -120 1 -167 -11 -32
-19 -36 -107 -66 -112 -37 -201 -81 -289 -142 -62 -43 -66 -45 -103 -34 -42
13 -112 63 -140 102 -29 39 -33 98 -9 136 41 65 129 88 267 70 l61 -9 6 42 c7
53 46 112 88 134 51 25 150 18 185 -14z m2688 9 c14 -11 26 -28 25 -37 0 -13
-2 -12 -9 4 -5 12 -14 25 -20 29 -7 4 -7 -1 2 -15 12 -19 10 -24 -15 -46 -35
-30 -70 -39 -110 -27 -29 8 -32 13 -33 50 -2 33 2 43 20 51 38 19 111 14 140
-9z m-2250 -71 c12 -33 13 -44 4 -50 -43 -26 -43 -26 -24 -47 22 -24 13 -41
-21 -41 -18 0 -36 -11 -54 -32 l-27 -33 -13 28 c-13 28 -13 28 -21 7 -6 -17
-14 -21 -33 -18 -28 6 -31 -1 -12 -22 10 -12 9 -12 -5 -1 -35 26 -21 86 33
149 l29 33 0 -27 c0 -15 -7 -36 -16 -46 -16 -16 -15 -18 0 -24 10 -4 22 -17
27 -30 11 -31 27 -30 41 1 9 19 19 25 45 25 35 0 42 10 19 30 -8 6 -17 21 -19
33 -4 19 -4 19 -6 -3 0 -15 4 -31 11 -38 9 -9 5 -12 -20 -12 -18 0 -32 -3 -32
-7 0 -5 -4 -14 -9 -21 -6 -11 -14 -8 -34 12 -21 21 -23 27 -11 37 8 6 14 22
14 36 0 21 3 22 20 13 14 -8 26 -8 40 0 28 15 25 21 -4 10 -17 -6 -29 -5 -42
5 -17 12 -14 15 31 44 27 17 54 31 60 31 7 0 19 -19 29 -42z m-484 -278 c21
-40 21 -41 1 -68 -56 -79 -113 -105 -214 -98 -81 6 -125 16 -129 31 -6 23 262
174 309 175 7 0 22 -18 33 -40z m1191 -109 c13 -10 30 -16 37 -14 6 3 12 0 12
-7 0 -6 -4 -8 -10 -5 -22 14 -8 -14 15 -29 31 -20 46 -21 19 -1 -16 13 -17 16
-4 25 29 19 91 3 117 -30 9 -12 17 -13 45 -2 60 21 107 10 74 -18 -17 -13 -60
-16 -96 -6 -14 4 3 -7 37 -23 42 -20 69 -40 83 -63 26 -43 26 -24 0 22 l-21
35 25 -29 c21 -25 25 -26 33 -12 8 14 14 15 37 6 16 -6 36 -8 46 -5 22 7 35
-32 17 -54 -9 -12 -9 -13 1 -7 6 4 12 2 12 -3 0 -21 18 -11 24 14 7 29 18 32
36 10 27 -33 -22 -46 -115 -31 -39 6 -299 32 -381 38 l-42 3 -6 -65 c-9 -99
-7 -234 5 -310 14 -95 12 -104 -23 -86 -20 11 -28 12 -29 3 0 -7 -47 82 -105
197 -96 192 -104 210 -89 226 9 9 20 32 25 49 13 45 -27 90 -87 98 -42 6 -43
5 -43 -25 0 -16 -9 -40 -20 -53 -23 -28 -26 -15 -5 21 25 45 20 60 -22 59 -21
0 -32 -3 -25 -6 17 -7 15 -66 -3 -111 -12 -26 -18 -33 -24 -23 -6 10 -10 10
-16 1 -4 -6 -17 -15 -29 -20 -15 -6 -6 -8 29 -5 39 4 33 1 -25 -10 -41 -8 -86
-14 -100 -12 -17 3 -13 5 12 6 20 0 40 5 43 11 4 6 -6 7 -24 4 -18 -4 -37 -2
-45 5 -11 9 -15 8 -20 -5 -3 -8 -11 -14 -17 -12 -6 2 -9 6 -7 10 2 3 -8 15
-22 27 -21 17 -23 22 -10 31 8 5 10 10 4 10 -7 0 -26 -16 -43 -35 -56 -64 -32
-135 51 -152 21 -4 28 -11 28 -29 0 -19 -23 -54 -35 -54 -2 0 -23 31 -47 70
-24 40 -50 70 -59 70 -14 0 -15 7 -8 45 14 73 54 117 155 168 79 40 162 60
244 60 85 -1 131 -16 193 -65 29 -23 39 -28 34 -15 -6 15 -3 17 13 12 11 -4
20 -2 20 4 0 6 -6 11 -12 11 -19 0 -98 56 -91 64 4 3 15 6 25 6 10 0 18 5 18
10 0 6 5 10 11 10 6 0 8 -9 3 -22 -6 -21 -6 -21 10 -5 14 13 21 14 36 5 16
-11 22 -9 35 7 11 16 17 17 23 7 7 -10 11 -10 22 3 16 19 22 19 51 -4z m1349
-16 c59 -31 62 -82 7 -116 -65 -39 -167 -9 -167 49 0 68 87 105 160 67z
m-2279 -57 c10 -13 18 -30 19 -38 0 -15 -77 -70 -99 -70 -17 0 -14 -7 21 -58
21 -31 31 -56 30 -76 -2 -16 3 -33 9 -37 8 -4 -12 -19 -50 -38 -44 -23 -63
-28 -66 -19 -26 72 -61 290 -51 307 3 5 27 10 53 13 27 3 62 12 78 20 17 9 32
16 33 17 2 1 12 -9 23 -21z m2014 -4 c81 -39 37 -95 -86 -110 -49 -6 -59 -4
-78 15 -27 27 -27 61 1 96 19 25 26 27 72 23 29 -2 70 -13 91 -24z m-2423
-186 c25 -35 78 -94 117 -132 40 -38 70 -70 69 -71 -2 -1 -22 -14 -45 -28
l-42 -26 -24 42 c-13 23 -37 70 -52 105 l-28 64 -35 -7 c-69 -13 -138 -45
-180 -85 -29 -28 -51 -40 -71 -40 -28 0 -29 2 -21 30 5 16 20 45 34 63 40 53
180 145 222 147 5 0 31 -28 56 -62z m1538 32 c138 -13 318 -41 459 -71 l104
-22 -7 -114 c-6 -108 -8 -118 -49 -199 l-43 -85 -19 23 c-11 13 -13 17 -5 11
17 -15 30 -17 30 -3 0 5 13 38 30 72 16 34 29 63 27 64 -3 3 -287 54 -300 54
-13 0 42 -61 185 -207 l120 -122 -11 -135 -10 -135 -79 -98 -79 -98 -209 12
c-115 6 -232 12 -260 12 l-51 1 -8 188 c-4 103 -8 202 -9 220 l-1 33 195 -1
c115 0 191 3 185 8 -56 50 -312 270 -327 282 -20 13 -20 13 -15 -15 4 -17 9
-61 13 -98 l6 -68 54 -34 c73 -47 69 -53 -6 -8 -33 19 -60 37 -60 39 0 3 -9
62 -21 132 -14 86 -19 165 -18 247 1 66 3 123 5 126 2 3 16 4 31 3 15 -2 80
-8 143 -14z m-347 -307 l136 -288 6 -101 7 -102 -49 -15 c-26 -8 -76 -22 -109
-32 l-62 -18 19 -66 c22 -75 22 -78 10 -66 -5 6 -19 42 -31 80 -30 93 -191
488 -203 496 -5 3 9 9 32 13 22 3 42 10 45 15 4 7 -82 -6 -91 -13 -1 -1 6 -31
17 -66 l19 -64 -44 -174 -43 -175 38 -78 37 -79 -36 6 c-43 8 -53 14 -23 14
12 0 22 3 22 8 -1 14 -29 57 -30 45 0 -7 -12 -13 -27 -14 l-28 -1 25 -8 c20
-7 15 -8 -22 -7 -26 0 -45 4 -42 9 3 4 -2 8 -10 8 -8 0 -22 7 -31 17 -16 15
-15 17 7 30 12 8 16 13 8 10 -8 -2 -47 -12 -87 -22 l-72 -19 51 -55 c28 -31
60 -68 71 -84 13 -17 23 -23 28 -16 3 6 9 -1 11 -15 3 -15 2 -25 -2 -24 -4 2
-47 48 -95 103 -75 86 -86 103 -82 130 8 61 178 830 186 845 7 14 208 56 282
59 24 1 34 -17 162 -286z m-579 111 c31 -53 55 -98 53 -101 -5 -4 -81 104 -89
127 -11 33 -20 -232 -13 -408 6 -168 4 -196 -14 -282 -12 -52 -21 -97 -21
-101 0 -4 38 -52 84 -106 l85 -98 -57 -17 c-112 -34 -99 -37 -213 58 -57 47
-105 87 -106 88 -1 1 -7 56 -13 121 -16 185 -20 209 -32 197 -7 -7 -6 -61 3
-171 l13 -162 98 -82 c54 -45 98 -84 98 -87 0 -3 -36 -14 -80 -24 l-79 -19
-122 74 c-139 84 -127 66 -159 249 -27 162 -40 303 -40 444 l0 122 101 60 c56
32 106 61 110 62 5 2 9 -30 9 -71 0 -96 10 -168 22 -161 6 4 9 56 7 128 l-4
121 70 34 c54 27 222 100 232 101 0 0 26 -43 57 -96z m1726 16 c139 -54 241
-104 237 -114 -2 -6 -12 -55 -22 -108 -11 -61 -22 -98 -30 -98 -6 0 -56 18
-110 40 -54 22 -100 40 -102 40 -1 0 -3 -6 -3 -13 0 -8 46 -32 111 -57 97 -38
110 -46 105 -64 -2 -12 -8 -42 -11 -67 -11 -72 -10 -72 -114 -43 -51 14 -95
23 -98 20 -13 -12 12 -25 79 -41 40 -9 83 -20 94 -25 l22 -8 -20 -96 c-16 -81
-29 -112 -84 -208 -36 -62 -69 -116 -72 -119 -4 -3 -41 3 -82 13 -68 16 -50
17 41 2 l36 -6 57 101 c31 56 56 103 56 105 0 2 -79 18 -175 37 l-175 33 0 60
c0 112 31 553 46 658 l6 37 76 -29 c42 -15 102 -38 132 -50z m369 -147 c47
-37 128 -109 180 -159 l94 -92 -7 -83 c-10 -124 -26 -209 -40 -209 -7 0 -33
13 -59 30 -34 21 -47 26 -47 15 0 -8 16 -116 36 -241 19 -124 34 -227 32 -229
-4 -3 -181 -55 -189 -55 -3 0 -7 89 -8 198 -1 108 -6 274 -12 367 -5 94 -10
177 -10 185 -3 40 5 39 82 -14 44 -31 82 -56 85 -56 2 0 4 6 4 14 0 11 -175
136 -191 136 -2 0 -1 -33 2 -72 3 -40 7 -137 8 -216 l2 -144 -95 -112 c-88
-104 -98 -113 -123 -107 l-28 6 30 4 c24 2 46 22 105 94 41 50 76 94 78 98 5
11 -138 33 -147 23 -14 -14 -111 -186 -111 -195 0 -5 10 -10 23 -10 16 -1 17
-3 5 -6 -10 -2 -24 -1 -32 4 -12 7 -4 27 45 115 l60 106 59 313 c71 368 69
359 76 359 3 0 45 -30 93 -67z m-2729 -155 c0 -82 16 -293 25 -334 4 -18 -7
-29 -66 -64 l-71 -42 29 -15 c15 -8 54 -28 87 -45 32 -16 56 -32 53 -35 -10
-9 -317 157 -317 172 0 1 27 19 60 39 33 21 60 44 60 52 0 9 -28 -4 -79 -38
l-79 -53 67 -48 c36 -27 72 -52 79 -56 8 -4 22 -59 35 -129 l22 -121 35 -15
c19 -9 61 -25 93 -37 88 -32 62 -32 -44 -1 l-94 28 -83 -54 -82 -55 142 -37
143 -37 57 61 c32 33 59 58 62 55 2 -2 -21 -32 -53 -66 l-56 -63 -164 43 -164
42 -18 53 c-47 140 -87 432 -74 540 6 52 8 53 98 127 101 83 278 213 290 214
4 1 7 -36 7 -81z m1226 -567 c53 -24 84 -68 84 -119 l0 -39 -62 31 c-35 17
-65 34 -68 38 -3 4 -39 23 -80 42 l-75 34 35 16 c47 21 116 20 166 -3z m-335
-16 c174 -30 285 -81 449 -204 138 -104 166 -128 159 -135 -3 -4 -31 5 -61 19
-55 25 -208 68 -215 61 -8 -7 48 -89 103 -152 40 -46 50 -64 42 -72 -9 -9 -9
-12 0 -12 7 0 12 3 12 8 0 4 21 8 48 8 50 2 117 18 142 34 12 8 9 15 -20 45
l-35 36 47 89 47 89 -37 11 c-20 6 -63 13 -94 17 -52 5 -56 7 -45 24 15 24 29
24 52 -1 23 -26 47 -25 63 1 18 28 62 22 80 -11 l13 -25 -3 30 c-5 61 24 71
81 28 20 -14 30 -20 24 -13 -23 25 -16 43 15 36 15 -4 32 -7 38 -8 6 -1 9 -12
6 -25 -3 -16 1 -24 14 -29 11 -3 27 -10 37 -15 11 -6 24 -6 35 0 33 18 152 -2
152 -25 0 -2 -9 0 -19 6 -54 29 -125 -11 -123 -70 0 -19 10 -42 23 -56 l22
-23 -32 12 c-18 6 -42 27 -53 45 -24 38 -35 35 -20 -5 6 -15 10 -35 10 -43 0
-52 12 -123 23 -137 13 -15 12 -15 -8 -3 -18 12 -26 12 -47 0 -33 -17 -37 -69
-6 -77 17 -5 18 -7 4 -20 -10 -10 -13 -25 -9 -44 5 -22 2 -30 -16 -40 -13 -6
-34 -22 -48 -35 -14 -14 -34 -27 -43 -30 -10 -3 -18 -10 -18 -15 0 -5 -12 -9
-26 -9 -22 0 -24 3 -19 23 5 16 2 14 -13 -9 -26 -41 -84 -67 -159 -72 -60 -4
-64 -3 -90 27 -15 17 -32 31 -38 31 -5 0 -3 -5 5 -10 13 -9 13 -11 0 -20 -18
-12 -60 -13 -60 -2 0 4 5 13 12 20 17 17 -3 14 -27 -4 -13 -9 -30 -12 -50 -8
-60 13 -74 48 -26 67 28 10 28 12 14 34 -8 12 -13 28 -11 35 3 7 -11 21 -30
31 l-35 19 -25 -25 -25 -25 22 -11 c21 -12 30 -64 13 -75 -5 -3 -6 8 -4 24 6
39 -33 60 -74 41 -15 -6 -29 -9 -32 -7 -3 3 9 11 26 19 28 11 29 14 15 32 -18
25 -63 112 -63 122 0 4 16 -21 35 -56 49 -90 51 -92 86 -52 l31 33 23 -22 c15
-14 33 -20 51 -18 38 4 43 27 7 34 -15 3 -36 11 -46 19 -15 11 -16 16 -5 40
14 30 12 33 -124 141 -57 45 -58 45 -58 20 0 -36 -10 -32 -47 17 -76 101 -132
215 -148 300 -8 44 -12 43 106 22z m-52 -238 c16 -28 55 -83 86 -121 30 -38
55 -79 54 -90 -1 -15 -3 -12 -10 9 -4 17 -21 43 -37 58 l-28 27 4 -33 c5 -43
-37 -97 -76 -98 -26 -1 -26 -1 5 -12 46 -17 52 -27 55 -82 l3 -50 -40 -3 c-34
-2 -49 3 -88 33 -26 20 -47 44 -47 53 1 20 34 62 49 62 6 0 11 5 11 10 0 6 -7
10 -15 10 -22 0 -48 46 -43 75 3 14 1 28 -3 31 -5 3 -9 -2 -9 -10 0 -20 -32
-36 -66 -34 -15 2 -29 -2 -31 -8 -5 -16 -54 -4 -61 15 -3 9 -10 19 -16 24 -7
4 -2 14 14 28 24 19 24 20 2 9 -49 -24 -74 45 -27 76 31 20 45 11 46 -29 0
-18 3 -26 6 -19 2 6 19 12 36 13 30 1 30 1 7 8 -27 7 -42 51 -18 51 7 0 23 3
36 6 16 5 22 2 22 -10 0 -9 5 -16 10 -16 6 0 10 8 10 18 0 12 17 23 58 38 31
11 60 19 64 17 4 -2 20 -27 37 -56z m-507 -375 l38 -37 -41 -52 -40 -53 -49
37 c-54 40 -54 40 -41 76 6 16 20 26 40 30 18 4 34 13 37 22 8 21 14 19 56
-23z m-209 -73 c34 -17 89 -53 122 -79 58 -46 195 -182 195 -194 0 -7 -141
-49 -146 -43 -3 2 23 14 56 26 71 26 71 27 -17 114 l-59 58 -42 -50 c-35 -41
-39 -51 -27 -61 12 -10 22 -5 57 28 38 36 58 44 58 24 0 -4 -20 -20 -45 -35
-25 -16 -45 -31 -45 -34 0 -3 8 -12 18 -21 26 -24 4 -11 -44 27 l-40 31 47 52
c27 29 46 54 43 57 -2 3 -25 -18 -50 -47 -25 -29 -49 -52 -53 -52 -4 0 -34 23
-65 50 -31 28 -53 50 -47 50 5 0 13 -4 16 -10 3 -5 11 -10 16 -10 6 0 8 4 5 9
-3 4 0 32 8 60 12 47 12 53 -4 61 -10 5 -20 6 -24 3 -3 -3 -6 -1 -6 5 0 17 3
16 73 -19z m332 -31 c38 -28 52 -45 45 -52 -5 -5 -10 -18 -10 -28 0 -12 -16
-26 -45 -40 l-45 -22 -40 40 -40 40 37 51 c21 29 39 53 40 53 1 0 27 -19 58
-42z m-408 -168 c-36 -74 1 -146 80 -157 31 -4 45 1 79 25 39 28 41 29 62 12
l21 -18 -36 -36 c-74 -73 -166 -72 -244 3 -47 45 -49 50 -49 102 0 44 6 65 31
103 l30 48 23 -21 23 -22 -20 -39z"/>
<path d="M2460 2897 c-51 -17 -126 -93 -139 -144 -32 -121 74 -226 213 -209
160 18 258 191 169 296 -53 64 -150 87 -243 57z m163 -11 c18 -7 46 -28 62
-45 26 -28 30 -40 30 -90 0 -77 -33 -128 -106 -165 -123 -61 -261 -9 -276 104
-19 137 155 254 290 196z"/>
<path d="M2420 2772 c-42 -14 -64 -65 -42 -98 13 -19 50 -34 86 -34 72 0 124
82 79 123 -17 15 -90 21 -123 9z"/>
<path d="M1950 1329 c0 -27 4 -48 9 -45 5 3 14 -7 21 -23 11 -27 15 -29 93
-34 45 -4 147 -10 228 -13 l145 -7 62 78 c34 43 62 81 62 86 0 5 -139 9 -310
9 l-310 0 0 -51z"/>
<path d="M970 1243 c-8 -3 -26 -10 -39 -15 l-24 -9 30 -22 c17 -12 60 -47 97
-78 l66 -56 59 16 c33 9 62 19 65 21 2 3 -20 32 -51 65 -30 33 -52 52 -49 43
3 -11 -2 -19 -15 -23 -27 -9 -99 4 -128 22 l-24 16 24 13 c24 13 17 17 -11 7z"/>
<path d="M786 1165 c-33 -14 -65 -25 -73 -25 -28 0 -8 -17 85 -73 l97 -58 63
16 c34 10 62 20 62 24 -1 7 -153 134 -166 138 -5 1 -36 -9 -68 -22z"/>
</g>
</svg>

</template>

<script>
  export default {
		name: 'PhaserIcon',
    props: {
      icon: {
        type: String,
        default: '$cancel'
      }
    }
  }
</script>
<style scoped>
svg{
	fill:currentColor;
}
</style>>
